import { isExternalUrl, hasLocalePrefix, toPath } from '~/utils/urlHelpers'

/**
 * Returns a resolver that turns any href into a full absolute URL.
 * External URLs (different host) are returned as-is.
 * Internal paths/URLs delegate to useFullLocalizedUrl, passing alreadyLocalized
 * when the path already contains a locale prefix.
 */
export const useFullLinkUrl = () => {
  const { baseUrl } = useRuntimeConfig().public as { baseUrl: string }
  const withLocale = useFullLocalizedUrl(true)
  const withoutLocale = useFullLocalizedUrl(false)

  return (href: string): string => {
    if (isExternalUrl(href, baseUrl)) return href
    const path = toPath(href)
    return hasLocalePrefix(path) ? withLocale(path) : withoutLocale(path)
  }
}
